<script>
export default {
  props: ['item'],
  data() {
    return {
      loading: false,
    }
  },
  computed: {

  },
  created() {

  },
  methods: {
    submit_form() {
      if(this.loading == true) { console.log("disabled"); return; } this.loading = true;
      this.$emit('setpage', 8);
      this.loading = false;
    }
  }
}
</script>

<template>

  <div class="_w-m-1000 mx-auto my-5">
    <form @submit.prevent="submit_form()">
      <div class="text-center mb-5">
        <img :src="formatImage('/fm/revinre-nc/clip art/Property details.png')" class="_w-m-400" data-aos="fade-zoom-in">
        <h3 class="mb-3" data-aos="fade-zoom-in">Property details</h3>
        <p class="text-muted" data-aos="fade-zoom-in">In this section, we will collect all of the information required to place your property on the MLS. Once the listing input form is complete, you will then move on to our photo uploader, unless you selected a package with professional photography. In the final "Sign Paperwork" step, we will compile all of the forms required to list your property on the MLS using the data you have entered and send them to your email address for signatures.</p>
      </div>

      <div class="row py-5">
        <div class="col-6">

        </div>
        <div class="col-6 text-right">
          <button type="submit" class="btn btn-lg btn-success" :disabled="loading"><span class="spinner-border spinner-border-sm" v-show="loading"></span> Next <Icon icon="ri:arrow-right-double-fill" /></button>
        </div>
      </div>
    </form>
  </div>

</template>
